module.exports = __webpack_public_path__ + "img/plan-2.864d4b33.png";